import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import RoleStore from './RoleStore';
import { Map, List } from 'immutable';

function addRolesFromOrganization(state, organization) {
  return state.set(organization.id, new List(organization.roles.map(role => role.id)));
}

class RolesByOrganizationStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    this.getDispatcher().waitFor([RoleStore.getDispatchToken()]);

    switch (action.actionType) {
      case Constants.Admin.ORGANIZATION_LOADED:
        return addRolesFromOrganization(state, action.organization);
      default:
        return state;
    }
  }

  getRolesForOrganization(organizationId) {
    return this.get(organizationId).map((roleId) => RoleStore.get(roleId)).toList();
  }

  get(id, defaultValue = new List()) {
    return this.getState().get(id, defaultValue);
  }
}

const instance = new RolesByOrganizationStore(AppDispatcher);
export default instance;
